<template>
  <div
    class="fill-height d-flex justify-center align-center light-gradient"
  >
    <div class="d-flex flex-column align-center justify-center py-10">
      <animated-logo
        indeterminate
        size="75"
      />
      <v-progress-circular
        indeterminate
        size="75"
        color="#A0A0A0"
        class="mt-10"
      />
    </div>
  </div>
</template>

<script>
import AnimatedLogo from '@/components/AnimatedLogo'
export default {
  name: 'LoadingView',
  components: { AnimatedLogo }
}
</script>
